import React from 'react'
import { Link, NavLink, Redirect, Route, Switch } from 'react-router-dom'
import { AppBar, Toolbar, Typography } from '@mui/material'

import AsteroidCalc from './apps/AsteroidCalc'
import IncursionCalculator from './apps/IncursionCalculator'

import style from './Main.module.css'

const Main = () => {

  return <>
    <AppBar position='static'>
      <Toolbar>
        <Typography variant='subtitle1'><Link className={style.link} to='./'>EVE Online Tools</Link></Typography>
        <div className={style.tabs}>
          <NavLink className={style.tab} activeClassName={style.activeLink} to='/incursions'>Incursion Calculator</NavLink>
          <NavLink className={style.tab} activeClassName={style.activeLink} to='/asteroids'>Asteroid Calculator</NavLink>
        </div>
        <Typography variant='subtitle1'>a collection of tools by <a className={style.link} href='https://chajij.eu/'>Ajaqa Chajij</a></Typography>
      </Toolbar>
    </AppBar>
    <Switch>
      <Route path='/incursions'><IncursionCalculator/></Route>
      <Route path='/asteroids'><AsteroidCalc/></Route>
      <Route path='/'><Redirect to={'/incursions'}/></Route>
    </Switch>
  </>
}

export default Main
